<div
  [ngStyle]="{
    height: '66px',
    'background-color': (group?.background_color)[0],
    'background-size': 'cover',
    'background-position': '50% 50%',
    'background-repeat': 'no-repeat',
    'background-image':
      group?.background_image_url && 'url(' + group?.background_image_url + ')',
  }"
></div>
<div class="u-padding-16">
  <div
    *ngIf="membership"
    class="u-marginBottom-16"
    fxLayout="row"
    fxLayoutGap="8px"
  >
    <a
      class="text-subtitle-1 u-textDecoration-underline--hover"
      [routerLink]="['.']"
      [queryParams]="{ group: group?.slug }"
      queryParamsHandling="merge"
      >{{ group?.name }}
    </a>
  </div>
  <div
    *ngIf="pendingMembership"
    class="u-marginBottom-16"
    fxLayout="row"
    fxLayoutGap="8px"
  >
    <a
      class="text-subtitle-1 u-textDecoration-underline--hover"
      (click)="openPendingHubDialog(group, pendingMembership)"
      >{{ group?.name }}
    </a>
    <mat-icon
      i18n-matTooltip="@@profileView.groupItem.pendingMembership.tooltip"
      matTooltip="Your request to join is under review"
      class="color-orange"
      >info
    </mat-icon>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    [ngStyle]="{ marginBottom: '4px', maxWidth: '100%' }"
  >
    <p i18n="@@global.role" class="u-paddingRight-8 color-grey-300">Role</p>
    <p class="u-textTruncate">
      {{
        membership?.role || pendingMembership?.role
          | translationLookup: ['@@groupRole']
      }}
    </p>
  </div>
  <div
    *ngFor="let segment of group?.custom_segments"
    fxLayout="row"
    fxLayoutAlign="start baseline"
    [ngStyle]="{ marginBottom: '4px' }"
  >
    <p
      class="u-paddingRight-8 color-grey-300 u-textTruncate"
      [ngStyle]="{ maxWidth: '50%' }"
    >
      {{ segment.title | translationLookup: ['@@groupCustomSegmentTitle'] }}
    </p>
    <p class="u-wordWrap-breakWord" [ngStyle]="{ 'max-width': '70%' }">
      <app-text-list
        *ngIf="getSegmentSelection(segment._id)?.multiselected_nodes?.length"
        [list]="
          getSegmentSelection(segment._id).multiselected_nodes
            | translationLookupList: ['@@groupCustomSegmentOption']
        "
        class="u-display-block color-grey"
      >
      </app-text-list>
    </p>

    <p
      *ngIf="!!getSegmentSelection(segment._id)?.node"
      [ngStyle]="{ maxWidth: '50%' }"
      class="u-textTruncate"
    >
      {{
        getSegmentSelection(segment._id)?.node
          | translationLookup: ['@@groupCustomSegmentOption']
      }}
    </p>
    <div
      *ngIf="
        !getSegmentSelection(segment._id)?.node &&
        !getSegmentSelection(segment._id)?.multiselected_nodes?.length
      "
      [ngStyle]="{ maxWidth: '50%' }"
    >
      <button
        i18n="@@profileView.groupItem.addSelection.label"
        *ngIf="isUser"
        class="c-button color-blue u-textDecoration-underline--hover"
        (click)="openHubSettingsDialog()"
      >
        Add selection
      </button>
      <p *ngIf="!isUser">
        <i i18n="@@profileView.hubs.notSpecified.label" class="color-grey-300"
          >Not specified</i
        >
      </p>
    </div>
  </div>
  @if (membership) {
    <a
      [queryParams]="{ group: group?.slug }"
      [routerLink]="['.']"
      class="color-grey-300 u-paddingTop-8 u-textDecoration-underline"
      queryParamsHandling="merge"
      i18n="@@profileView.groupItem.more.label"
    >
      More
    </a>
  }
  @if (pendingMembership) {
    <a
      [routerLink]="['.']"
      (click)="openPendingHubDialog(group, pendingMembership)"
      class="color-grey-300 u-paddingTop-8 u-textDecoration-underline"
      i18n="@@profileView.groupItem.more.label"
    >
      More
    </a>
  }
</div>
